// 新メールアドレス 確認画面
import React, { useState, useCallback } from 'react';
import './List.css';
import '../App.css';
import { Snackbar, Button, CircularProgress } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useHistory, Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isLoggedIn, mainBlueColor, btnColor } from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { confirmMail } from '../apicalls/confirmMail';
import logo from '../assets/logo1.png';

export const ConfirmMailPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }
    })
  );

  const classes = useStyles();

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const confirmNewMailAddress = () => {
    setLoading(true);
    confirmMail(history.location.pathname.split('/confirm/email/')[1]).then(
      data => {
        setLoading(false);
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          setLoading(false);
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
              setTimeout(() => {
                history.push('/employee-master/create', {
                  state: data.data.user_id
                });
              }, 2000);
            }
          }
        }
      }
    );
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <div
        className={classes.container}
        style={{
          backgroundColor: buttonColor,
          padding: 15,
          minHeight: window.innerHeight - 30
        }}
      >
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openSuccess}
          autoHideDuration={4000}
          onClose={handleCloseSuccess}
        >
          <Alert onClose={handleCloseSuccess} severity='success'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <div
          style={{
            width: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
          className='container'
        >
          <div>
            <img
              style={{ width: 100, height: 60, objectFit: 'contain' }}
              alt='logo'
              src={logo}
            />
          </div>
          <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 10 }}>
            Verify your email address
          </div>
          <div style={{ fontSize: 14, textAlign: 'center' }}>
            Please confirm that you want to use this as your email address.
          </div>
          {loading && (
            <div style={{ position: 'absolute' }}>
              <CircularProgress style={{ color: mainColor }} />
            </div>
          )}
          <Button
            onClick={() => {
              confirmNewMailAddress();
            }}
            style={{ backgroundColor: mainColor, marginTop: 20, width: 400 }}
            variant='contained'
            color='primary'
          >
            メールアドレスの確認
          </Button>
        </div>
      </div>
    </div>
  );
};
